import * as tslib_1 from "tslib";
import { InterfaceService } from "@app/interfaces";
import { BehaviorSubject, Subject } from "rxjs/index";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngx-translate/core";
var LicenseContractService = /** @class */ (function (_super) {
    tslib_1.__extends(LicenseContractService, _super);
    function LicenseContractService(http, translate) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.translate = translate;
        _this.sidePanelDataSubject = new BehaviorSubject([
            {
                stepText: _this.translate.instant('licenses.m'),
                id: 'License',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: true,
                isStepDisable: false,
                sequence: 1,
            },
            {
                stepText: 'Add signature',
                id: 'Signature',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: false,
                isStepDisable: false,
                sequence: 2,
            },
            {
                stepText: 'Confirmation',
                id: 'Signature',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: false,
                isStepDisable: false,
                sequence: 3,
            },
            {
                stepText: 'Add-on details',
                id: 'License1',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: true,
                isStepDisable: false,
                sequence: 4,
            },
            {
                stepText: 'Add signature',
                id: 'Signature1',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: false,
                isStepDisable: false,
                sequence: 5,
            },
            {
                stepText: 'Confirmation',
                id: 'confirmation1',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: false,
                isStepDisable: false,
                sequence: 6,
            }
        ]);
        _this.progressAccountType = new BehaviorSubject([
            {
                stepText: 'Licence/Add-on',
                id: 'License',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: true,
                isStepDisable: false,
                sequence: 1,
            },
            {
                stepText: 'Confirmation',
                id: 'Signature',
                stepRouting: ['contract_license'],
                isStepRequired: true,
                stepPermission: true,
                isStepCompleted: false,
                stepActive: false,
                isStepDisable: false,
                sequence: 2,
            }
        ]);
        _this.closeModalSubject = new Subject();
        _this.closeModal$ = _this.closeModalSubject.asObservable();
        _this.refreshLicensingDataSource = new Subject();
        _this.refreshLicensingData$ = _this.refreshLicensingDataSource.asObservable();
        _this.closeResetSubject = new Subject();
        _this.closeReset$ = _this.closeResetSubject.asObservable();
        _this.resetSubject = new Subject();
        _this.reset$ = _this.resetSubject.asObservable();
        _this.stepSource = new BehaviorSubject(1);
        _this.step$ = _this.stepSource.asObservable();
        _this.purchaseOrderDataFetched$ = new Subject(); // shared observable
        return _this;
    }
    LicenseContractService.prototype.getLicenseStorage = function (params) {
        return this.http
            .get(this.getApiUrl('getStorageLicenseDetails', params));
    };
    LicenseContractService.prototype.getMasterContractNew = function () {
        var queryParams = { isNewLicencing: 1 };
        return this.http.get(this.getApiUrl('getNewMasterContractDetails', queryParams));
    };
    LicenseContractService.prototype.getMasterContract = function (params) {
        return this.http
            .get(this.getApiUrl('getMasterContractDetails', params));
    };
    LicenseContractService.prototype.getLicenseDetails = function (params) {
        return this.http
            .get(this.getApiUrl('getLicenseDetails', params));
    };
    LicenseContractService.prototype.getPurchaseOrder = function (isNewLicencing, id, params) {
        var queryParams = {
            isNewLicencing: isNewLicencing,
            contractId: id,
            limit: params.limit,
            page: params.page
        };
        return this.http.get(this.getApiUrl('getPurchaseorderDetails', queryParams));
    };
    LicenseContractService.prototype.saveNewLicense = function (clientID, licenceTypeID, pricingPlanID, quantity, licenceID, commitmentID, emailid, pricingTemplateID, licenceName) {
        var isLicenceBased = true;
        var isAddon = false;
        var queryParams = { clientID: clientID, licenceTypeID: licenceTypeID, pricingPlanID: pricingPlanID, quantity: quantity, licenceID: licenceID, commitmentID: commitmentID, emailid: emailid, pricingTemplateID: pricingTemplateID, licenceName: licenceName, isLicenceBased: isLicenceBased, isAddon: isAddon };
        return this.http.post(this.getApiUrl('postPurchaseNewLicenses'), queryParams);
    };
    // Licensed add-on purchase (license-based)
    LicenseContractService.prototype.purchaseLicensedAddOnPackage = function (payload) {
        return this.http.post(this.getApiUrl('addons/purchase'), payload);
    };
    // Non-licensed add-on purchase (credits/sms/etc.)
    LicenseContractService.prototype.purchaseNonLicensedAddOnPackage = function (payload) {
        return this.http.post(this.getApiUrl('addons/purchase'), payload);
    };
    LicenseContractService.prototype.saveLicense = function (data) {
        return this.http
            .post(this.getApiUrl('postPurchaseLicenses'), JSON.stringify(data));
    };
    LicenseContractService.prototype.getUserLicense = function (params) {
        return this.http
            .get(this.getApiUrl('get_adduservalidation', params));
    };
    LicenseContractService.prototype.getAllocatedLicense = function (params) {
        return this.http
            .get(this.getApiUrl('allocated_licence', params));
    };
    LicenseContractService.prototype.getLicensePriceDetails = function (clientID, licenceID, licenceTypeID, licenceTypesDetailsID, pricingPlanId, quantity) {
        var queryParams = {
            'clientID': clientID,
            'licenceID': licenceID,
            'licensetypeid': licenceTypeID,
            'licencetypedetailsid': licenceTypesDetailsID,
            'pricingPlanId': pricingPlanId,
            'nooflicences': quantity
        };
        return this.http
            .get(this.getApiUrl('product_licence/price', queryParams));
    };
    LicenseContractService.prototype.deleteNewLicenses = function (clientID, licenceTypeID, licensesQuantity, productID, licenceTypeCommitments, licenses) {
        var queryParams = {
            'clientId': clientID,
            'licensetypeid': licenceTypeID,
            'licensesquntity': licensesQuantity,
            'productid': productID,
            'licencetypecommitments': licenceTypeCommitments,
            'licenceid': licenses
        };
        return this.http.delete(this.getApiUrl('postDeleteNewLicenses', queryParams));
    };
    LicenseContractService.prototype.deleteLicenses = function (data) {
        return this.http
            .post(this.getApiUrl('postDeleteLicenses'), JSON.stringify(data));
    };
    Object.defineProperty(LicenseContractService.prototype, "sidePanelData$", {
        get: function () {
            return this.sidePanelDataSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    LicenseContractService.prototype.updateStepData = function (updatedData) {
        var currentData = this.sidePanelDataSubject.value;
        var updatedSidePanelData = currentData.map(function (step) {
            return step.sequence === updatedData.sequence ? tslib_1.__assign({}, step, updatedData) : step;
        });
        this.sidePanelDataSubject.next(updatedSidePanelData);
    };
    LicenseContractService.prototype.getSidePanelContractDetails = function () {
        return this.sidePanelDataSubject.value;
    };
    Object.defineProperty(LicenseContractService.prototype, "sidePanelDataAccountType$", {
        get: function () {
            return this.progressAccountType.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    LicenseContractService.prototype.updateStepDataAccountType = function (updatedData) {
        var currentData = this.progressAccountType.value;
        var updatedSidePanelData = currentData.map(function (step) {
            return step.sequence === updatedData.sequence ? tslib_1.__assign({}, step, updatedData) : step;
        });
        this.progressAccountType.next(updatedSidePanelData);
    };
    LicenseContractService.prototype.getSidePanelContractDetailsAccountType = function () {
        return this.progressAccountType.value;
    };
    LicenseContractService.prototype.closeModal = function () {
        this.closeModalSubject.next();
    };
    LicenseContractService.prototype.triggerRefreshLicensingData = function (from) {
        this.refreshLicensingDataSource.next({ from: from });
    };
    LicenseContractService.prototype.triggerCloseAndReset = function () {
        this.closeResetSubject.next();
    };
    LicenseContractService.prototype.triggerReset = function () {
        this.resetSubject.next();
    };
    LicenseContractService.prototype.emitPurchaseOrderDataFetched = function (status) {
        this.purchaseOrderDataFetched$.next(status);
    };
    LicenseContractService.prototype.setStep = function (step) {
        this.stepSource.next(step);
    };
    LicenseContractService.prototype.getEversignDocumentStatus = function (documentId, params) {
        var url = this.getApiUrl("eversign_document/" + documentId + "/status", params);
        return this.http.get(url);
    };
    LicenseContractService.prototype.cancelClientLicenceDocument = function (clientsLicenceId) {
        var url = "cancel_client_licence_document/" + clientsLicenceId;
        return this.http.put(this.getApiUrl(url), {});
    };
    LicenseContractService.prototype.downloadContract = function (contractId) {
        var url = "download_contract/" + contractId;
        return this.http.get(this.getApiUrl(url), { responseType: 'blob' });
    };
    LicenseContractService.prototype.getUsers = function (isOwnerOrManager) {
        if (isOwnerOrManager === void 0) { isOwnerOrManager = 1; }
        return this.http.get(this.getApiUrl('get_users', { isOwnerOrManager: isOwnerOrManager }));
    };
    LicenseContractService.prototype.contractContact = function (userId) {
        var url = 'clients/contract_contact';
        var payload = { userId: userId };
        return this.http.put(this.getApiUrl(url), payload);
    };
    LicenseContractService.ngInjectableDef = i0.defineInjectable({ factory: function LicenseContractService_Factory() { return new LicenseContractService(i0.inject(i1.HttpClient), i0.inject(i2.TranslateService)); }, token: LicenseContractService, providedIn: "root" });
    return LicenseContractService;
}(InterfaceService));
export { LicenseContractService };
